var map = {
	"./analysis-act.png": "f044",
	"./analysis.png": "5501",
	"./buystore-act.png": "ec9e",
	"./buystore.png": "4892",
	"./classroom-act.png": "fc41",
	"./classroom.png": "4201",
	"./courses-act.png": "d894",
	"./courses.png": "5e03",
	"./home-act.png": "cf70",
	"./home.png": "a5c0",
	"./kifu-act.png": "0347",
	"./kifu.png": "6f9c",
	"./play-act.png": "182c",
	"./play.png": "c630"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6860";